import { createFeatureSelector, createSelector, select } from '@ngrx/store';
import { filter, map, pipe } from 'rxjs';

import { batchesFeatureKey, BatchState } from 'app/shared/features/batch-selector/state/batch.reducer';

import { Batch } from '../models/batch';

export const selectBatchesState = createFeatureSelector<BatchState>(batchesFeatureKey);

export const selectBatches = createSelector(selectBatchesState, (state) => state.batches);

export const selectBatchesIfLoaded = pipe(
    select(selectBatches),
    filter((list): list is Batch[] => !!list),
);

export const selectBatchNameByNumber = (batchNumber: number | undefined) =>
    createSelector(selectBatches, (batches) => batches.find((batch) => batch.number === batchNumber)?.name);

export const selectBatchByNumber = (batchNumber: number) =>
    pipe(
        selectBatchesIfLoaded,
        map((batches) => batches.find((batch) => batch.number === batchNumber)),
    );
